import React from "react";
import "./Certifications.css";

const certifications = [
  {
    src: "/img/GOTS.jpeg",
    alt: "GOTS",
    title: "Global Organic Textile Standard",
  },

  {
    src: "/img/GRS.jpeg",
    alt: "GRS",
    title: "Global Recycled Standard",
  },
  {
    src: "/img/Organic 100 Content Standard.png",
    alt: "Organic 100",
    title: "Organic 100 Content Standard",
  },

  {
    src: "/img/BCI.jpeg",
    alt: "BCI",
    title: "Better Cotton Initiative",
  },

  {
    src: "/img/fairtrade.jpeg",
    alt: "Fairtrade",
    title: "Fairtrade International",
  },
];

export default function Certifications() {
  return (
    <div className="certifications-container">
      <h2 className="certifications-title">Certifications</h2>
      <div className="certifications-scroll-wrapper">
        <div className="certification-logos">
          {certifications.map((cert, idx) => (
            <img key={idx} src={cert.src} alt={cert.alt} title={cert.title} />
          ))}
        </div>
      </div>
    </div>
  );
}
